var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4532_27763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 7.99805C20.6569 7.99805 22 6.6549 22 4.99805C22 3.34119 20.6569 1.99805 19 1.99805C17.3431 1.99805 16 3.34119 16 4.99805C16 6.6549 17.3431 7.99805 19 7.99805Z",
    fill: "#CC2F2C",
    stroke: "#393A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.437 10.4887C19.4793 10.8241 19.5004 11.1617 19.5 11.4997V17.9997C19.5 18.3976 19.658 18.7791 19.9393 19.0604C20.2206 19.3417 20.6022 19.4997 21 19.4997H2C2.39782 19.4997 2.77936 19.3417 3.06066 19.0604C3.34196 18.7791 3.5 18.3976 3.5 17.9997V11.4997C3.50111 10.2791 3.78127 9.07479 4.31905 7.97897C4.85684 6.88314 5.63803 5.92476 6.60292 5.17707C7.56781 4.42938 8.69085 3.91217 9.88624 3.66496C11.0816 3.41775 12.3177 3.44709 13.5 3.75074",
    stroke: "#393A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.499023V3.49902",
    stroke: "#393A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9498 21.5C13.835 22.0651 13.5284 22.5732 13.0819 22.9382C12.6354 23.3031 12.0765 23.5025 11.4998 23.5025C10.9231 23.5025 10.3642 23.3031 9.91768 22.9382C9.47117 22.5732 9.16456 22.0651 9.0498 21.5",
    stroke: "#393A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4532_27763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.23c264157654e927b157b481c052e45c.svg";
export { ForwardRef as ReactComponent };